import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import './index.less';

import actions from 'Actions/taskManage/questionNaire';

import echarts from 'echarts/lib/echarts';
import ReactEcharts from 'echarts-for-react';
import EmptyImg from 'Static/images/empty.png';

class Pie extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      projectData: [],
    };
  }

  componentDidMount() {
    // const {actions} = this.props;
    // actions.getQuestionNaireConnect({
    //   startMillis: 0,
    //   endMillis: 0,
    //   taskId: 0,
    // });
  }

  componentWillReceiveProps(nextProps) {
    const {pieData} = this.props;
    if (JSON.stringify(nextProps.pieData) !== JSON.stringify(pieData)) {
      if (
        nextProps.pieData.filter(e => e.value === 0).length !==
        nextProps.pieData.length
      ) {
        this.setState({
          projectData: nextProps.pieData,
        });
      } else {
        this.setState({
          projectData: [],
        });
      }
    }
  }

  getOption = data => {
    const option = {
      color: [
        '#40AEFC',
        '#34CB82',
        '#5D7092',
        ' rgba(246,189,22,0.85)',
        'rgba(232,104,74,0.85)',
        'rgba(232,104,74,0.85)',
        'rgba(146,112,202,0.85)',
        'rgba(255,157,77,0.85)',
        'rgba(38,154,153,0.85)',
        'rgba(255,153,195,0.85)',
        'rgba(91,143,249,0.85)',
        'rgba(189,210,253,0.85)',
      ],
      tooltip: {
        // trigger: 'axis',
        backgroundColor: '#fff',
        textStyle: {
          color: '#191F25',
        },
        axisPointer: {
          type: 'shadow',
        },
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        itemWidth: 10,
        right: 0,
        top: '10%',
        data: [
          {
            name: '无法接通',
            icon: 'circle',
          },

          {
            name: '空号',
            icon: 'circle',
          },
          {
            name: '接听后挂断',
            icon: 'circle',
          },
          {
            name: '转人工',
            icon: 'circle',
          },
          {
            name: '无人接听',
            icon: 'circle',
          },
          {
            name: '占线',
            icon: 'circle',
          },
          {
            name: '关机',
            icon: 'circle',
          },
          {
            name: '停机',
            icon: 'circle',
          },
          {
            name: '号码错误',
            icon: 'circle',
          },
          {
            name: '网络异常',
            icon: 'circle',
          },
          {
            name: '无法识别',
            icon: 'circle',
          },
        ],
      },
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: ['50%', '75%'],
          width: '30px',
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '20',
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data,
        },
      ],
    };
    return option;
  };

  render() {
    const {projectData} = this.state;
    return (
      <div className="pie">
        <div className="title">
          <span>接通情况</span>
        </div>
        {projectData.length > 0 ? (
          <ReactEcharts
            echarts={echarts}
            option={this.getOption(projectData)}
            notMerge
            lazyUpdate
            style={{
              width: '100%',
              height: '72%',
              left: -100,
              top: 25,
            }}
            className="react_for_echarts"
          />
        ) : (
          <div className="empty-tips">
            <img src={EmptyImg} alt="" />
            <div>暂无数据</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({taskManageQuestionNaire}) => ({
  pieData: taskManageQuestionNaire.pieData,
  tableListData: taskManageQuestionNaire.tableListData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pie);
